import net, { IRequestOptions, IRequestOptionsWithPass } from '@/services/net'
import { PackEntityUserInfoVO } from '../Type/PackEntityUserInfoVO'

/**
				 *	查询登录用户的信息
				
				*/

export function userInfo(options: IRequestOptionsWithPass): Promise<PackEntityUserInfoVO>
export function userInfo(
	options?: IRequestOptions,
): Promise<PackEntityUserInfoVO extends { msg: unknown } ? PackEntityUserInfoVO['msg'] : undefined>
export function userInfo(options: IRequestOptionsWithPass | IRequestOptions = {}) {
	return net('/frontApi/home/userInfo', {
		method: 'post',

		...(options || {}),
	})
}
